import { searchvoucherTransactionRefundReport, searchvoucherTransactionRefundReportExport, postVoucherSync } from "apis/siigo.api";
import { DataTable, Icon, Text, } from "components/commons";
import { VenueContext, AppContext } from "contexts";
import { useApi, useFilter, useMount, useRouter, useSelectItems } from "hooks";
import { siigoVoucherReportRequest } from "mappers/siigo.mapper";
import React, { useCallback, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { mapObject } from "services";
import { HeaderA } from "components/headers";
import { voucherTransactionReportFilterState } from "./filters";
import VoucherTransactionReportFilter from "./voucher-transaction-report-filter";
import lang from "translations";
import { ModuleWrapper } from "components/fragments";
import { formatNumberToMoneyWithCurrencySymbol } from "services/money.service";
import {
  Button,
  Toast,
} from "components";
import { InvoicedSiigo } from "enums";
import { Path } from "paths";
import {
  dateToTimeAgo
} from "../../../mappers/common.mapper";
import { prettifyInvoiced } from "services/pretty.service";
import { v4 as uuidv4 } from "uuid";
import { Tooltip } from "antd";
import styles from "./invoices.css";
import classNames from "classnames";

const VoucherType = {
  TOPUP: "TOPUP",
  REFUND: "RETURN",
  ADJUSTMENT: "ADJUSTMENT",
};

const VoucherTransactionReport = () => {
  const { venue } = useContext(VenueContext);
  const { setGlobalLoading } = useContext(AppContext);
  const location = useLocation();
  let voucherType = VoucherType.REFUND;
  let title="";
  if (location.pathname.includes("topup")) {
    voucherType = VoucherType.TOPUP;
    title = lang.topup;
  } else if (location.pathname.includes("refund")) {
    voucherType = VoucherType.REFUND;
    title = lang.refund;
  } else if (location.pathname.includes("adjustment")) {
    voucherType = VoucherType.ADJUSTMENT;
    title = lang.adjustment;
  }
  
  const history = useRouter();

  

  const {
    request: searchvoucherTransactionReportRequest,
    loading: loadingvoucherTransactionReports,
    result: searchvoucherTransactionReportResult = {
      data: { data: [] },
      pageSize: 0,
      pageNumber: 1,
      total: 0,
    },
    error: errorvoucherTransactionReports,
    mappedData
  } = useApi({
    api: searchvoucherTransactionRefundReport,
    isArray: true,
    params: {
      voucherType
    },
    mapper : {
      id: {
        key: "voucherSiigoId",
      },
      voucherId: {
        key: "voucherId",
      },
      voucherType: {
        key: "voucherType",
      },
      checkinId: {
        key: "checkinId",
      },
      customerName: {
        key: "customerName",
      },
      issueDate: dateToTimeAgo("issuedDate"), 
      // issueDate: {
      //   key: "issuedDate",
      // },
      amount: {
        key: "amount",
        formatter: formatNumberToMoneyWithCurrencySymbol,
      },
      status: {
        key: "status",
        custom: true,
      },
      error : {
        key: "errorReason",
      },
      voucherSiigoId : {
        key: "voucherSiigoId",
      }
    }
  });


  const {
    request: searchvoucherTransactionReportExportRequest,
    loading: searchvoucherTransactionReportExportLoading,
  } = useApi({
    api: searchvoucherTransactionRefundReportExport,
    params: {
      reportType: "REFUND_REPORT_REGISTRATION"
    },
  });
  

  const { modifyFilter, modifyFilters, filterState, requestState, clearFilter } = useFilter(
    voucherTransactionReportFilterState(venue)
  );

  useMount(() => {
    fetchvoucherTransactionReports(filterState, requestState);
  });

  const fetchvoucherTransactionReports = useCallback(
    (filterState, requestState) => {
      var datatoaspss = mapObject({ ...requestState }, siigoVoucherReportRequest);
      searchvoucherTransactionReportRequest(datatoaspss);
    },
    [searchvoucherTransactionReportRequest]
  );

  const clearFilterCb = useCallback(
    (filterState, requestState) => {
      fetchvoucherTransactionReports(filterState, requestState);
    },
    [fetchvoucherTransactionReports]
  );

  const applyFilterCb = useCallback(
    (searchKey) => {
      const { filterState, requestState } = modifyFilters({
        page: 1,
        searchKey,
      });
      fetchvoucherTransactionReports(filterState, requestState);
    },
    [fetchvoucherTransactionReports, modifyFilters]
  );

  const sortCb = useCallback(
    ({ value, key }) => {
      const { filterState, requestState } = modifyFilters({ sort: { key, value } });
      fetchvoucherTransactionReports(filterState, requestState);
    },
    [fetchvoucherTransactionReports, modifyFilters]
  );

  const exportXlsx = useCallback(() => {
    searchvoucherTransactionReportExportRequest(
      mapObject({ ...requestState }, siigoVoucherReportRequest)
    );
  }, [searchvoucherTransactionReportExportRequest, requestState]);

  const noResult = useMemo(() => {
    return (
      <div className="pt-lg">
        <p className="text-xl text-gray-600">{lang.noReportsFound}</p>
        <p className="text-md text-gray-400">{lang.weDidNotFoundReports}</p>
      </div>
    );
  }, []);

const renderState = (state, errorReason = []) => {
  
  
  const text = prettifyInvoiced(state);
  let color = "bg-f3f2f1 text-gray border-gray";
  let icon;
  let before;

  switch (state) {
    case InvoicedSiigo.Sent:
      color = "bg-blue-lightest text-blue border-blue";
      break;
    case InvoicedSiigo.Created:
          color = "bg-green-lighter text-green-darker border-green-darker";
          break;
    case InvoicedSiigo.Error:
      before = <div className="w-1 h-5 bg-red-lighter"></div>;
      color = "bg-faebed text-red-lighter border-red-lighter";
      icon = (
        <Tooltip
          title={
            <div className="" style={{ width: 491, maxWidth: 491 }}>
              <div className="bg-red-100 text-red-lighter px-4 py-3">
                <Icon name={"warning"} /> {lang.error}
              </div>
              <div className="bg-white px-4 py-3">
                <Text size="text-md">{errorReason}</Text>
              </div>
            </div>
          }
          placement="topLeft"
        >
          <span>
            <Icon name={"warning"} />
          </span>
        </Tooltip>
      );
      break;
    default:
      color = "bg-faebed text-red-lighter border-red-lighter";
      icon = (
        <Tooltip
          title={
            <div className="" style={{ width: 400, maxWidth: 500 }}>
              <div className="bg-red-100 text-red-lighter px-4 py-3">
                <Icon name={"warning"} /> {lang.error}
              </div>
              <div className="bg-white px-4 py-3">
                
                  <Text size="text-md" key={uuidv4()}>
                     <Text size="text-md">{errorReason}</Text>
                  </Text>
                
              </div>
            </div>
          }
          placement="topLeft"
          overlayClassName={styles["ant-tooltip"]}
          color="white"
        >
          <span>
            <Icon name={"warning"} />
          </span>
        </Tooltip>
      );
  }

  return (
    <div
      className={classNames(
        "h-10 border border-solid inline-flex justify-center items-center gap-2 px-3 rounded-lg text-md whitespace-nowrap",
        color
      )}
    >
      {before}
      {text}
      {icon}
    </div>
  );
};

  const voucherTransactionReportsData = useMemo(() => {
    return mappedData?.map(
      ({ voucherId, voucherType, checkinId, customerName, issueDate, amount, id, status, error, voucherSiigoId }) => {
        
        return {
          id,
          voucherId,
          voucherType,
          checkinId,
          customerName,
          issueDate:  <Text size="text-md">{issueDate?.date}</Text>,
          voucherSiigoId,
          amount: formatNumberToMoneyWithCurrencySymbol(amount),
          error: renderState(
            status,
            (() => {
              if (!error) return undefined;
              try {
                const parsed = JSON.parse(error);
                return parsed?.messages || undefined;
              } catch {
                return undefined;
              }
            })()
          ),
        };
      }
    );
  }, [mappedData]);

  

  const onClickVoucher = useCallback(
    (id) => {
      if (voucherType === VoucherType.REFUND) {
        history.push(Path.SIIGO_REFUND_VOUCHER_DETAILS_ID(id));
      } else if (voucherType === VoucherType.TOPUP) {
        history.push(Path.SIIGO_TOPUP_VOUCHER_DETAILS_ID(id));
      } else if (voucherType === VoucherType.ADJUSTMENT) {
        history.push(Path.SIIGO_ADJUSTMENT_VOUCHER_DETAILS_ID(id));
      }
    },
    [history, voucherType]
  );

  const prepareColumns = useCallback(() => {

    return [
      {
        key: "id",
        text: lang.id,
      },
      {
        key: "voucherId",
        text: lang.voucher,
      },
      {
        key: "voucherType",
        text: lang.voucherType,
      },
      {
        key: "checkinId",
        text: lang.checkinId,
      },
      {
        key: "customerName",
        text: lang.customerName,
      },
      {
        key: "issueDate",
        text: lang.issueDate,
      },
      {
        key: "amount",
        text: lang.amount,
      },
      {
        key: "error",
        text: lang.error,
        custom: true
      },
      {
        key: "action",
        actions: true,
        align: "right",
        actionOptions: [
          {
            text: lang.viewDetails,
            onClick: (column) => {
              onClickVoucher(column.voucherSiigoId);
            },
          },
        ],
      },
    ];
  }, [onClickVoucher]);


    const {
    selected,
    setSelected,
    isAllSelected,
    setSelectAll,
    clearSelected,
    denormalizeItems,
  } = useSelectItems({
    items: mappedData,
    indeterminate: true
  });

  const onSelect = (voucherSiigoId) => {
    if(voucherSiigoId) setSelected(voucherSiigoId);
    // selectID.onSel(id);
  };

  const onSelectAll = () => {
    setSelectAll();
    // const ids = mappedData?.map(({ id }) => id);
    // if (!isAllSelected) selectID.onAdd(ids);
    // else selectID.onSub(ids);
  };

  const onResync = async (ids) => {
    try {
      setGlobalLoading(true);
      const data = ids.map((i) => ({
        voucherSiigoId: i
      }));
      await postVoucherSync(data);
      Toast({ content: lang.resyncSuccessfully, success: true, icon: "check" }).open();
      clearSelected();
    } catch (error) {
      Toast({ content: lang.somethingWentWrong, error: true, icon: "exclamation-fill" }).open();
    } finally {
      await fetchvoucherTransactionReports(requestState, filterState);
      setGlobalLoading(false);
    }
  };

  const enableSync = useMemo(() => {
    const arr = Object.values(selected);
    
    if (!arr.length) return false;
    for (let i = 0; i < arr.length; i++) {
      const el = arr[i];
      if (el.error && InvoicedSiigo.Error === el.status) {
        continue;
      } else return false;
    }
    return true;
  }, [selected]);
  
  const columns = useMemo(() => {
    return prepareColumns();
  }, [prepareColumns]);



  return (
    <ModuleWrapper>
      <HeaderA
        title={<>{title} {lang.voucherTransaction}</>}
        description={`View and manage ${title} voucher`}
        button={{
          iconPrefix: <Icon className="mr-sm" name="download" paddingless fontSize={12} />,
          text: lang.exportXlsx,
          loading: searchvoucherTransactionReportExportLoading,
          disabled: searchvoucherTransactionReportExportLoading,
          onClick: () => {
            exportXlsx();
          },
        }}
        className="mb-md"
      />

      <VoucherTransactionReportFilter
        filterState={filterState}
        requestState={requestState}
        modifyFilter={modifyFilter}
        clearFilter={clearFilter}
        onClear={clearFilterCb}
        onApply={applyFilterCb}
      />

      {voucherTransactionReportsData?.length > 0 || !loadingvoucherTransactionReports ? (
        <>
          <div className="flex justify-end gap-2 mb-4 mt-2">
            <Button
              onClick={() => onResync(denormalizeItems)}
              disabled={!enableSync}
            >
            {lang.resyncVoucher}
            </Button>
          </div>

          <DataTable
            page={filterState.page}
            pageSize={filterState.pageSize}
            onChangePage={modifyFilters}
            fetchList={fetchvoucherTransactionReports}
            total={searchvoucherTransactionReportResult?.data?.total || 0}
            loading={loadingvoucherTransactionReports}
            columns={columns}
            data={voucherTransactionReportsData}
            error={errorvoucherTransactionReports}
            sort={filterState.sort}
            setSort={sortCb}
            selected={selected}
            setSelectAll={onSelectAll}
            setSelected={onSelect}
            isAllSelected={isAllSelected}
            hasAppliedFilter={!!searchvoucherTransactionReportResult?.data?.total}
          />
        </>
      ) : (
        noResult
      )}
    </ModuleWrapper>
  );
};

export default VoucherTransactionReport;
